import { Home } from 'lucide-react';
import RecordManager from '../components/RecordManager';

export default function PropertyRecords() {
  return (
    <RecordManager
      apiPath="property-records"
      testid="property"
      title="Property Records"
      subtitle="Document homes, vehicles, and valuables — all in one secure place."
      icon={Home}
      accent="navy"
      addLabel="Add Property"
      emptyText="No property records yet. Add homes, vehicles, or valuables with supporting documents."
      titleField="name"
      subtitleFields={['property_type', 'location', 'estimated_value']}
      hasDocuments
      fields={[
        { name: 'name', label: 'Name / title', placeholder: 'e.g., Family Home, 2019 Honda CR-V' },
        { name: 'property_type', label: 'Type', type: 'select', options: ['Home / Real Estate', 'Vehicle', 'Land', 'Valuable / Jewelry', 'Collectible', 'Other'] },
        { name: 'description', label: 'Description', type: 'textarea', placeholder: 'Details about the property.' },
        { name: 'location', label: 'Location', placeholder: 'Address or where it is kept' },
        { name: 'estimated_value', label: 'Estimated value', placeholder: 'e.g., $250,000' },
        { name: 'account_or_policy', label: 'Account / policy #', placeholder: 'Mortgage, title, or policy number' },
        { name: 'notes', label: 'Notes', type: 'textarea', placeholder: 'Who it should go to, special instructions…' },
      ]}
    />
  );
}
